import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectPlatformIdParam } from '@/store/slices/platformSlice';

const PLATFORM_FILTER_HIDDEN_PATHS = [
  '/rolewise-account-statement',
  '/casino-management',
  '/event-management',
  '/bet-setting',
  '/roles-and-privileges',
  '/create-roles',
];

export const isPlatformFilterHiddenPath = (pathname: string) =>
  PLATFORM_FILTER_HIDDEN_PATHS.some((path) => pathname.startsWith(path));

export const usePlatformId = () => {
  const location = useLocation();
  const platformId = useSelector(selectPlatformIdParam);

  return isPlatformFilterHiddenPath(location.pathname) ? undefined : platformId;
};
